import React, { ReactElement, useContext } from 'react'
import styled from 'styled-components';
import { TabsContext } from './Tabs';

interface IProps {
    number: number,
    children: ReactElement
}

interface ITabPaneContainerProps {
    isCurrent: boolean
}

const TabPaneContainer = styled.div<ITabPaneContainerProps>`
    display: ${props => props.isCurrent ? "block" : "none"};
    width: 100%;      
`;

export default function TabPane(props: IProps) {
    const tabsContext = useContext(TabsContext);

    return (<TabPaneContainer isCurrent={tabsContext.step === props.number}>
        {tabsContext.step === props.number && <div>{props.children}</div>}

    </TabPaneContainer>)
}